<template>

  <div
    v-if="newOrder">

    <div
      class="buymodal-block__body">

      <div
        class="body-info">
        <div
          class="body-info__block">
          <div
            class="info-result">
            <img
              src="@/../static/img/icons/galka.svg">
            <div
              class="info-result__title">
              Заявка {{ model.btag }} успешно создана!
            </div>
            <div
              v-if="newOrder.pdflink"
              class="info-result__btn">
              <a
                :href="newOrder.pdflink"
                download
                class="btn next"
                style="text-decoration: none">
                Распечатать договор
              </a>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState('buyphones', ['model', 'newOrder', 'clientInfo']),
  },
  mounted() {
    if (!this.newOrder)
      this.updateOrder({
        btag: this.model.btag,
        data: {
          client: {
            name: this.clientInfo.lastname + ' ' + this.clientInfo.firstname + ' ' + this.clientInfo.patronymic,
            passportNumber: "",
            passportSerial: this.clientInfo.passportserial,
            passportIssued: this.clientInfo.passportwho,
            passportDate: this.clientInfo.passportdate.replace(/\./g, ''),
            address: this.clientInfo.address,
            email: this.clientInfo.email,
            phone: this.clientInfo.telefon.replace(/\+/g, ''),
            birthday: this.clientInfo.date.replace(/\./g, ''),
          }
        }
      });
  },
  methods: {
    ...mapActions('buyphones', ['updateOrder']),
  }
}
</script>

<style lang="css">
</style>
